(function () {
    'use strict';
    var scrollCounter = 0;

    angular.module('SMART2').directive('smartScroll', ['$parse', '$timeout', '$window', function ($parse, $timeout, $window) {
        return {
            restrict: 'EA',
            replace: false,
            transclude: true,
            scope: true,
            link: function (scope, element, attrs) {
                //Setting for fixed header on scroll
                var isFixedHeader = attrs.isFixedHeader ? true : false,
                    isScrollDate = attrs.hideDate == 'true' ? true : false,
                    onBreakPoints = attrs.onBreakPoints ? $parse(attrs.onBreakPoints.replace(/\(\)/, '(e)')) : false,
                    onScrollLockUnlock = attrs.onScrollLockUnlock ? $parse(attrs.onScrollLockUnlock.replace(/\(\)/, '(e)')) : false;

                scope.fixedHeader = function (e) {
                    var _this = $(e.target),
            		tableElem = _this.find(">").eq(0).find(">").eq(0), // this is depending on the smartScroll directive html structure!
            		 elScrollTop = _this.scrollTop();

                    if (elScrollTop > 0 && !_this.data('appended')) {
                        // reset display styles so column widths are correct when measured below
                        tableElem.find('thead, tbody, tfoot').css('display', '');

                        // set widths of columns
                        tableElem.find('tr:first-child th').each(function (i, thElem) {
                            var tdElems = tableElem.find('tbody > tr:first-child > td').eq(i),
            				columnWidth = tdElems.length ? tdElems.get(0).offsetWidth : thElem.offsetWidth;

                            if (tdElems.length) {
                                tdElems.css('width', columnWidth + 'px');
                            }
                            if (thElem) {
                                $(thElem).css('width', columnWidth + 'px');
                            }
                        });

                        var tbl = $('<table>');
                        var theader = tableElem.find('thead tr:first-child').clone();
                        tableElem.find('thead tr:first-child').css('opacity', '0');
                        tbl.append(theader);
                        tbl.addClass("fixed-header-when-scrolled");
                        _this.before(tbl);
                        _this.data('appended', true);
                    }
                };

                function scrollBreakPoints(scrollTop, direction) {
                    if (attrs.scrollBreakPoints) {
                        var breakPConfig = JSON.parse(attrs.scrollBreakPoints),
                            BCkeys = Object.keys(breakPConfig),
                            srElements = element.find(BCkeys.join(","));

                        for (var z = 0; z < BCkeys.length; z++) {
                            element.find(BCkeys[z]).data("configSele", BCkeys[z]);
                        }

                        if (srElements.length > 0) {
                            srElements.each(function (i, e) {
                                var el = $(e),
                                    pos = el.position(),
                                    bConfig = breakPConfig[el.data("configSele")],
                                    touchValue = function () {
                                        var r;
                                        if (typeof bConfig.top == "number") {
                                            r = bConfig.top * parseInt(scope.scrollHeight);
                                        } else {
                                            r = parseInt(bConfig.top);
                                        }

                                        return r;
                                    }();

                                if (direction == "upward" && pos.top <= touchValue && !el.data("fired")) {
                                    el.data("fired", true);
                                    onBreakPoints(scope, {
                                        e: {
                                            index: i,
                                            direction: "upward"
                                        }
                                    });
                                    scope.$digest();
                                } else if (direction == "downward" && ((bConfig.reverse === true ? pos.top + el.outerHeight() : pos.top) >= (touchValue)) && el.data("fired")) {
                                    el.data("fired", false);
                                    onBreakPoints(scope, {
                                        e: {
                                            index: i,
                                            direction: "downward"
                                        }
                                    });
                                    scope.$digest();
                                };
                            });
                        };
                    };
                };

                //unique ID for scroll
                scrollCounter = scrollCounter + 1;
                scope.scrollid = 'scroll-' + scrollCounter;

                //custom config
                var customConfig;
                attrs.$observe('scrollConfig', function (value) {
                    if (value) {
                        customConfig = scope.$eval(attrs.scrollConfig);
                    };
                });

                //scroll config
                var scrollConfig = {},
                onScrollEnd = $parse(attrs.onScrollEnd),
                onScrollToTop = $parse(attrs.onScrollToTop),
                onScrollInProgress = $parse(attrs.onScrollInProgress);

                attrs.$observe('height', function (value) {
                    if (value) {
                        if (angular.isFunction(onScrollEnd) || angular.isFunction(onScrollToTop)) {
                            scrollConfig.onScroll = function (y, x) {
                                if (y.maxScroll > 0 && y.scroll >= y.maxScroll && angular.isFunction(onScrollEnd)) {
                                    onScrollEnd(scope, { e: "" });
                                }
                                if (y.scroll == 0 && angular.isFunction(onScrollToTop)) {
                                    onScrollToTop(scope, { e: "" });
                                }
                                else if (y.maxScroll > y.scroll > 0 && angular.isFunction(onScrollInProgress)) {
                                    onScrollInProgress(scope, { e: "" });
                                }
                                angular.element('.fixeddd').hide();
                            };
                        }


                        if (!attrs.vOffset) {
                            if (value == "parent") {
                                scope.scrollHeight = element.parent().outerHeight();
                                $(window).resize(resizeHeight100P);
                            } else {
                                scope.scrollHeight = value;
                            }
                        } else if (attrs.vOffset) {
                            // If scroll to be responsive excluding an offset
                            $(window).unbind("resize", resizeHeight100P);
                            scope.scrollHeight = $window.innerHeight - parseInt(attrs.vOffset);
                        } else {
                            scope.scrollHeight = value;
                        }
                    }
                });

                function resizeHeight100P(a) {
                    scope.scrollHeight = element.parent().outerHeight();
                    scope.$digest();
                };

                if (attrs.vOffset || attrs.hOffset) {
                    // Resize event if scroll to be responsive excluding an offset
                    $(window).bind('resize', function () {
                        scope.scrollHeight = $window.innerHeight - parseInt(attrs.vOffset);
                        scope.$digest();
                        $timeout(function () {
                			if (attrs.vOffset) {
                				if (element.closest('.modal').length > 0) {
                					var modalHeight = element.closest('.modal').height();
                					element.closest('.modal').css('top', window.innerHeight / 2 - modalHeight / 2 + 'px');
                				}
                			}
                		});
                	});
                }
                attrs.$observe('vOffset', function (newVal) {
                    scope.scrollHeight = $window.innerHeight - parseInt(newVal);
                });
                scope.$on('scrollTopToBottom', function (event, args) {
                    element.find('.scrollbar-outer').animate({ scrollTop: args }, "slow");
                });

                var onScrollHEnd = $parse(attrs.onScrollHEnd);
                var onScrollHToTop = $parse(attrs.onScrollHToTop);
                var onScrollHInProgress = $parse(attrs.onScrollHInProgress);

                var eleWidth = element.css('width');
                scope.scrollWidth = parseInt(eleWidth) ? eleWidth : '100%';

                attrs.$observe('width', function (value) {
                    if (value) {
                        if (angular.isFunction(onScrollHEnd) || angular.isFunction(onScrollHToTop)) {
                            scrollConfig.onScroll = function (y, x) {
                                if (x.maxScroll > 0 && x.scroll == x.maxScroll && angular.isFunction(onScrollHEnd)) {
                                    onScrollHEnd(scope, { e: "" });
                                }
                                if (x.scroll == 0 && angular.isFunction(onScrollHToTop)) {
                                    onScrollHToTop(scope, { e: "" });
                                }
                                else if (x.maxScroll > x.scroll > 0 && angular.isFunction(onScrollHInProgress)) {
                                    onScrollHInProgress(scope, { e: "" });
                                }
                            };
                        };
                        scope.scrollWidth = value;
                    }
                });

                attrs.$observe('connectScrolls', function (value) {
                    if (value) {
                        var value = JSON.parse(value),
                			scrollTopSourceStorage = 0;

                        scrollConfig.onScroll = function (y, x) {
                            var $vSource = $('.' + value.vSource),
							$vSourceP = $vSource.parent().parent(),
							$hSource = $('.' + value.hSource),
							$hSourceP = $hSource.parent().parent(),
							$vertical = $('.' + value.vertical),
							$verticalP = $vertical.parent().parent(),
                			$horizontal = $('.' + value.horizontal);

                            var sourceHeight = $vSource.height();
                            var scrollTopSource = $vSourceP.scrollTop(),
                			scrollTopConnect = $verticalP.scrollTop();

                            if (scrollTopSource > scrollTopSourceStorage) {
                                if (scrollTopSource > scrollTopConnect) {
                                    $verticalP.scrollTop(scrollTopSource);
                                }
                            }
                            else if (scrollTopSource < scrollTopSourceStorage) {
                                if (scrollTopSource < scrollTopConnect) {
                                    $verticalP.scrollTop(scrollTopSource);
                                }
                            }
                            else {
                                var scrollLeft = $hSourceP.scrollLeft();
                                $horizontal.scrollLeft(scrollLeft);
                            }
                            scrollTopSourceStorage = scrollTopSource;
                            angular.element('.fixeddd').hide();
                        };
                    }
                });

                function dateHideOnScroll(e) {
                    element.find("input.datepicker").each(function (i, el) {
                        var dobj = $(el).data("daterangepicker");
                        if (dobj && dobj.isShowing) {
                            dobj.hide()
                        }
                    });
                }
                //Cleaning floating elements on scroll
                var lastOpenSelectDD;
                function cleanFloatingElements(e) {
                    element.find("[id^=typeahead-]").each(function (i, el) {
                        var autoComplete = $(this).data().autocomplete;
                        if (autoComplete && autoComplete.visible) {
                            autoComplete.hide();
                        }
                    });
                    /* close select-dropdown */
                    var $selectDd = $window.lastOpenedDropdownConfig;
                    if ($selectDd && $selectDd != lastOpenSelectDD && $selectDd.origin.hasClass('select-dropdown')) {
                        $selectDd.origin.trigger('close');
                    }
                    lastOpenSelectDD = $selectDd;
                }
                //End of cleaning floating elements on scroll
                var lockScrollObser = false;
                attrs.$observe("lockScroll", function (a) {
                    if (!lockScrollObser) {
                        lockScrollObser = true;
                        $timeout(ls.bind(this, a));
                    } else {
                        ls(a);
                    }
                });

                function ls(a) {
                    if (a) {
                        var $scroller = element.find(".scroll-content");
                        if (a == "true") {
                            $scroller.data("scrolltop", $scroller.scrollTop());
                            $scroller.get(0).addEventListener("scroll", lockScroll, true);
                            if (onScrollLockUnlock) {
                                onScrollLockUnlock(scope, { e: 'locked' });
                                scope.$digest();
                            }
                        } else if (a == "false") {
                            $scroller.get(0).removeEventListener("scroll", lockScroll, true);
                            if (onScrollLockUnlock) {
                                onScrollLockUnlock(scope, { e: 'unLocked' });
                                scope.$digest();
                            }
                        }
                    }
                };

                function lockScroll(e) {
                    var st = $(this).data("scrolltop");
                    this.scrollTop = st;
                    e.stopPropagation();
                    return false;
                };

                var scrollOnUpdate = {
                        handlers: [],
                        addHandlers: function (func) {
                            this.handlers.push(func);
                        }
                    };

                scrollConfig.onUpdate = function () {
                    var _this = this,
                        _arguments = arguments;

                    scrollOnUpdate.handlers.forEach(function (func) {
                        if (typeof func === "function") {
                            func.apply(_this, _arguments);
                        }
                    });
                };

                scrollOnUpdate.addHandlers(function (y, x) {
                    if (y.closest('.modal.noTransform').length > 0) {
                        var modalHeight = y.closest('.modal').height();
                        y.closest('.modal').css('top', window.innerHeight / 2 - modalHeight / 2 + 'px');
                    }
                });

                var scrollToElement,
                    scrollToElementName;
                if (attrs.scrollToElement) {

                    scrollOnUpdate.addHandlers(function (y, x) {
                        var $scrollToElementName = y.find(scrollToElementName.content);
                        if (scrollToElementName && scrollToElementName.status && $scrollToElementName.length) {
                            y.animate({ scrollTop: (($scrollToElementName.offset().top - y.children('div').offset().top) - 10) }, "slow");
                        }
                    });

                    scrollToElement = attrs.$observe('scrollToElement', function (value) {
                        scrollToElementName = attrs.scrollToElement && JSON.parse(attrs.scrollToElement);
                    });
                }

                setTimeout(function () {
                    var scrollWrapper = angular.element('#' + scope.scrollid);
                    var mergedConfig = angular.merge(scrollConfig, customConfig);
                    scrollWrapper.scrollbar(mergedConfig);

                    //Fixed header on scroll
                    var scrlTop;
                    scrollWrapper.scroll(function (e) {
                        var _this = $(this),
                            currScrlTop = _this.scrollTop(),
                            dir;

                        if (isFixedHeader) {
                            scope.fixedHeader(e);
                        } else if (isScrollDate) {
                            dateHideOnScroll(e);
                        }
                        if (attrs.scrollBreakPoints) {
                            if (currScrlTop > scrlTop) {
                                dir = "upward";
                            } else if (currScrlTop < scrlTop) {
                                dir = "downward";
                            };
                            scrollBreakPoints(currScrlTop, dir);
                        }
                        cleanFloatingElements(e);
                        scrlTop = currScrlTop;
                    });
                    scrlTop = scrollWrapper.scrollTop();

                    // for ie update the icon inside the smartscroll
                    var ua = window.navigator.userAgent, use = scrollWrapper.find('use');
                    if (ua.indexOf('MSIE') !== undefined || ua.indexOf('Trident/') !== undefined || ua.indexOf('Edge/') !== undefined) {
                        if (use.length > 0) {
                            use.each(function () {
                                var _this = angular.element(this), currentItem = _this.attr("xlink:href");
                                _this.attr("xlink:href", "").attr("xlink:href", currentItem);
                            });

                        }
                    }
                });

                scope.$on('$destroy', function () {
                    if (scrollToElement) {
                        scrollToElement();
                    }

                });
            },
            templateUrl: 'shared/directives/uiElements/smartScroll/smartScrollTemplate.html'
        };
    }]);
})();


(function () {
    'use strict';
    angular.module('SMART2').directive('smartLazyLoad', function () {
        return {
            restrict: 'A',
            scope: {
                smartLazyLoad: '&'
            },
            link: function (scope, element, attrs) {
                var scrollElement = element.closest('.scrollbar-outer');
                scrollElement.scroll(function () {
                    if (this.scrollTop + this.offsetHeight >= this.scrollHeight) {
                        scope.$apply(function () {
                            scope.smartLazyLoad();
                        });
                    }
                });
            }
        }
    });
})();